'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../../common');

var _utils = require('../../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatDate = _utils.FormattingUtils.formatDate;

var StatuteOfLimitationsInsight = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(StatuteOfLimitationsInsight, _Component);

  function StatuteOfLimitationsInsight() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StatuteOfLimitationsInsight);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StatuteOfLimitationsInsight.__proto__ || Object.getPrototypeOf(StatuteOfLimitationsInsight)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'caseType', _descriptor, _this), _initDefineProp(_this, 'statuteOfLimitations', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StatuteOfLimitationsInsight, [{
    key: 'renderExpirationDate',
    value: function renderExpirationDate() {
      var date_of_expiration = this.props.statuteOfLimitations.date_of_expiration;


      return _react2.default.createElement(
        'span',
        null,
        ' For this case it will ',
        _react2.default.createElement(
          'strong',
          null,
          'expire on ',
          formatDate(date_of_expiration)
        ),
        '.'
      );
    }
  }, {
    key: 'renderStatuteOfLimitations',
    value: function renderStatuteOfLimitations() {
      var _props$statuteOfLimit = this.props.statuteOfLimitations,
          state = _props$statuteOfLimit.state,
          time_to_expiration = _props$statuteOfLimit.time_to_expiration,
          date_of_expiration = _props$statuteOfLimit.date_of_expiration,
          trimmedCaseType = this.props.caseType.trim();


      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          state
        ),
        ' has a ',
        _react2.default.createElement(
          'strong',
          null,
          time_to_expiration
        ),
        ' statute of limitations for ',
        _react2.default.createElement(
          'strong',
          null,
          trimmedCaseType
        ),
        ' cases.',
        date_of_expiration ? this.renderExpirationDate() : ''
      );
    }
  }, {
    key: 'renderResourceURL',
    value: function renderResourceURL() {
      var resources = this.props.statuteOfLimitations.resources;


      if (resources.length) {
        return _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'a',
            { target: '_blank', href: resources[0] },
            'View External Resource'
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Row2.default,
        null,
        _react2.default.createElement(
          _common.InfoWell.Label,
          null,
          'STATUTE OF LIMITATIONS'
        ),
        _react2.default.createElement(
          _common.InfoWell.Value,
          null,
          this.renderStatuteOfLimitations(),
          this.renderResourceURL()
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return StatuteOfLimitationsInsight;
}(_react.Component), _class3.propTypes = {
  caseType: _propTypes2.default.string.isRequired,
  statuteOfLimitations: _propTypes2.default.shape({
    case_type: _propTypes2.default.number,
    date_of_expiration: _propTypes2.default.string,
    resources: _mobxReact.PropTypes.observableArray,
    state: _propTypes2.default.string.isRequired,
    time_to_expiration: _propTypes2.default.string.isRequired
  })
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'caseType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'statuteOfLimitations', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
})), _class2)) || _class) || _class;

var _default = StatuteOfLimitationsInsight;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatDate, 'formatDate', '/app/src/components/page-case/main-underwriting/StatuteOfLimitationsInsight.js');
  reactHotLoader.register(StatuteOfLimitationsInsight, 'StatuteOfLimitationsInsight', '/app/src/components/page-case/main-underwriting/StatuteOfLimitationsInsight.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-underwriting/StatuteOfLimitationsInsight.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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